import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { COUNT_INVITATIONS_PER_PAGE } from 'constants/constants';
import { useMutation } from '@apollo/client/react';
import {
  InviteUserDocument,
  InvitationsByLoanConsultantDocument,
  type InviteUserInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';

const useInviteUser = () => {
  const [inviteUserMutation] = useMutation(InviteUserDocument);
  const { formatMessage: t } = useIntl();

  const handleInviteUser = useCallback(
    async (
      variables: InviteUserInput,
      {
        setSubmitting,
        resetForm,
      }: { setSubmitting: (isSubmitting: boolean) => void; resetForm: () => void },
    ) => {
      try {
        await inviteUserMutation({
          variables: { input: { ...variables } },
          refetchQueries: [
            {
              query: InvitationsByLoanConsultantDocument,
              variables: {
                limit: COUNT_INVITATIONS_PER_PAGE,
                offset: 0,
                filter: '',
              },
            },
          ],
          awaitRefetchQueries: true,
        });
        resetForm();
        toast.success(t({ id: 'invite_user.successfully_sent' }));
      } catch (error) {
        const e = withRaw(toGraphqlError(error), error || '');
        toast.error(e.message);
      } finally {
        setSubmitting(false);
      }
    },
    [inviteUserMutation, t],
  );
  return handleInviteUser;
};

export default useInviteUser;
